import { type CaregiverRole } from '@libraries/typescript/api_client';

const ROLE_DISPLAY_NAMES: Record<CaregiverRole, string> = {
    rn: 'RN',
    lpn: 'LPN',
    cna: 'CNA',
    companion: 'Companion',
    hha: 'HHA',
    pt: 'PT',
    ot: 'OT',
    st: 'ST',
    msw: 'MSW',
    cpi: 'CPI',
    dsw: 'DSW',
    np: 'NP',
    pca: 'PCA',
    hcss: 'HCSS',
    acd: 'ACD',
    other: 'Other',
};

const ROLE_FULL_NAMES: Record<CaregiverRole, string> = {
    rn: 'Registered Nurse',
    lpn: 'Licensed Practical Nurse',
    cna: 'Certified Nursing Assistant',
    companion: 'Companion',
    hha: 'Home Health Aide',
    pt: 'Physical Therapist',
    ot: 'Occupational Therapist',
    st: 'Speech Therapist',
    msw: 'Medical Social Worker',
    cpi: 'Certified Patient Instructor',
    dsw: 'Direct Support Worker',
    np: 'Nurse Practitioner',
    pca: 'Personal Care Assistant',
    hcss: 'Home and Community Support Services',
    acd: 'Alternative Competency Demonstration',
    other: 'Other',
};

const ROLE_COLORS: Record<CaregiverRole, string> = {
    rn: 'border-0 bg-[#DBEAFE] text-blue-800 dark:bg-blue-950/50 dark:text-blue-300',
    lpn: 'border-0 bg-[#E0E7FF] text-indigo-800 dark:bg-indigo-950/50 dark:text-indigo-300',
    cna: 'border-0 bg-[#EDE9FE] text-purple-800 dark:bg-purple-950/50 dark:text-purple-300',
    hha: 'border-0 bg-[#F3E8FF] text-violet-800 dark:bg-violet-950/50 dark:text-violet-300',
    pt: 'border-0 bg-[#D1FAE5] text-green-800 dark:bg-green-950/50 dark:text-green-300',
    ot: 'border-0 bg-[#D1FAE5] text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-300',
    st: 'border-0 bg-[#CCFBF1] text-teal-800 dark:bg-teal-950/50 dark:text-teal-300',
    msw: 'border-0 bg-[#FED7AA] text-orange-800 dark:bg-orange-950/50 dark:text-orange-300',
    cpi: 'border-0 bg-[#FEF3C7] text-amber-800 dark:bg-amber-950/50 dark:text-amber-300',
    dsw: 'border-0 bg-[#FEF3C7] text-yellow-800 dark:bg-yellow-950/50 dark:text-yellow-300',
    np: 'border-0 bg-[#CFFAFE] text-cyan-800 dark:bg-cyan-950/50 dark:text-cyan-300',
    pca: 'border-0 bg-[#BAE6FD] text-sky-800 dark:bg-sky-950/50 dark:text-sky-300',
    hcss: 'border-0 bg-[#F9A8D4] text-pink-800 dark:bg-pink-950/50 dark:text-pink-300',
    acd: 'border-0 bg-[#F0ABFC] text-fuchsia-800 dark:bg-fuchsia-950/50 dark:text-fuchsia-300',
    other: 'border-0 bg-[#F3F4F6] text-gray-800 dark:bg-gray-950/50 dark:text-gray-300',
    companion:
        'border-0 bg-[#FFE4E6] text-rose-800 dark:bg-rose-950/50 dark:text-rose-300',
};

/**
 * Get the display name for a caregiver role (e.g., "rn" -> "RN")
 */
export function getRoleDisplayName(role: CaregiverRole): string {
    return ROLE_DISPLAY_NAMES[role];
}

/**
 * Get the full name for a caregiver role (e.g., "rn" -> "Registered Nurse")
 */
export function getRoleFullName(role: CaregiverRole): string {
    return ROLE_FULL_NAMES[role];
}

/**
 * Get the color styling for a caregiver role badge
 */
export function getRoleColor(role: CaregiverRole): string {
    return ROLE_COLORS[role];
}
